import { Link } from 'react-router-dom';

export default function ExpenseTrackerCTA() {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-600 via-green-600 to-teal-700 p-8 shadow-2xl">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 h-60 w-60 rounded-full bg-white/10 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 h-40 w-40 rounded-full bg-white/10 blur-2xl"></div>
      
      <div className="relative z-10">
        <div className="flex items-start justify-between gap-6 flex-wrap">
          <div className="flex-1 min-w-[280px]">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-yellow-400 text-yellow-900 font-bold text-sm mb-4">
              <span className="animate-pulse">⭐</span>
              <span>NEW PREMIUM TOOL</span>
            </div>
            
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
              Stop Guessing About Your Expenses
            </h3>
            
            <p className="text-lg text-emerald-50 mb-6 leading-relaxed">
              Professional expense tracking with <strong className="text-white">real-time audit risk scoring</strong>. 
              Know exactly which deductions are safe and what documentation you need.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              <div className="flex items-start gap-2">
                <span className="text-emerald-300 text-xl flex-shrink-0">✓</span>
                <span className="text-white font-medium">Unlimited expense tracking</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-emerald-300 text-xl flex-shrink-0">✓</span>
                <span className="text-white font-medium">Audit risk analysis</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-emerald-300 text-xl flex-shrink-0">✓</span>
                <span className="text-white font-medium">Bank transaction import</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-emerald-300 text-xl flex-shrink-0">✓</span>
                <span className="text-white font-medium">Receipt uploads & storage</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-emerald-300 text-xl flex-shrink-0">✓</span>
                <span className="text-white font-medium">Mileage tracking (67¢/mi)</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-emerald-300 text-xl flex-shrink-0">✓</span>
                <span className="text-white font-medium">Quarterly tax estimates</span>
              </div>
            </div>
            
            <div className="flex flex-wrap gap-3">
              <Link
                to="/tools/expense-tracker"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white text-emerald-700 rounded-xl font-bold text-lg hover:bg-emerald-50 transition-all transform hover:scale-105 shadow-xl"
              >
                <span>Start Free Trial</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
              
              <Link
                to="/tools/expense-tracker"
                className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-800/50 text-white rounded-xl font-semibold text-lg hover:bg-emerald-800 transition-all backdrop-blur-sm border border-emerald-400/20"
              >
                <span>View Demo</span>
              </Link>
            </div>
          </div>
          
          <div className="flex-shrink-0">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border border-white/20 min-w-[240px]">
              <div className="text-center">
                <div className="text-4xl font-bold text-emerald-600 mb-2">$5.99</div>
                <div className="text-sm text-slate-600 font-medium mb-4">per month</div>
                
                <div className="space-y-2 text-left text-sm text-slate-700">
                  <div className="flex items-center gap-2">
                    <span className="text-emerald-500">●</span>
                    <span>Cancel anytime</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-emerald-500">●</span>
                    <span>No setup fees</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-emerald-500">●</span>
                    <span>Instant activation</span>
                  </div>
                </div>
                
                <div className="mt-4 pt-4 border-t border-slate-200">
                  <div className="text-xs text-slate-500 mb-2">Trusted by 1,000+ contractors</div>
                  <div className="flex items-center justify-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                        <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
